import { render, staticRenderFns } from "./locale.vue?vue&type=template&id=47632906"
import script from "./locale.vue?vue&type=script&lang=js"
export * from "./locale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports